import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Store } from '@ngrx/store';

import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { selectLoggedInUserDataId, selectBooking, selectProviderOffer, selectCurrentCar } from 'src/app/common/store/state/app.state';
import { Observable } from 'rxjs';
import { RentActions } from 'src/app/common/store/actions/rent.actions';
import { DateRange, MatDatepickerModule } from '@angular/material/datepicker';
import { DealerBasicData, PaymentTermOption } from 'src/app/public/account/constants/dealer-basic-data';
import { Car } from 'src/app/public/car/models/car.model';
import { AppFunctions } from 'src/app/public/common/constants/app-functions';
import { ObjectData } from 'src/app/public/common/models/object-data.model';
import { BookingStatus, RentBasicData, BookingAction } from '../../constants/rent-basic-data';
import { BookingModif } from '../../models/booking-modif.model';
import { Booking } from '../../models/booking.model';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatRadioModule } from '@angular/material/radio';
import { MatDividerModule } from '@angular/material/divider';

import { MatInputModule } from '@angular/material/input';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';


@Component({
    selector: 'app-booking-dialog',
    templateUrl: './booking-dialog.component.html',
    styleUrls: ['./booking-dialog.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule, MatFormFieldModule, MatInputModule, MatSlideToggleModule, MatDialogModule, MatIconModule, MatDatepickerModule, MatRadioModule, MatDividerModule]
})
export class BookingDialogComponent implements OnInit{

  todayDate: Date;
  tomorrowDate: Date;
  yesterdayDate: Date;

  showBookingAddNew: boolean = false;
  showBookingCalendar: boolean = false;

  selectedDateRange: DateRange<Date>;
  
  currentUserId$: Observable<string>;
  currentUserId: string = "";
    
  booking$: Observable<Booking | undefined>;
  booking: Booking = new Booking();

  car$ : Observable<Car | null>;
  car: Car = new Car();

  BookingStatus = BookingStatus;
  isModification: boolean = false;
  isCompletion: boolean = false;

  insuranceOptionsList = RentBasicData.rentalInsuranceOptions;
  mileageOptionsList = RentBasicData.rentalMileageOptions;
  paymentTermOptions = DealerBasicData.paymentTermOptions;
  currentPaymentTermOptionIndex = 1;

  PAY_NOW_PERCENT = 10;
  DEPOSIT_PERCENT = 30;
  
  constructor(
    public dialogRef: MatDialogRef<BookingDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ObjectData,
    private store: Store,
    private router: Router, 
    private route: ActivatedRoute) {

      this.currentUserId$ = store.select(selectLoggedInUserDataId);

      this.booking$ = store.select(selectBooking(data.objectSource, data.offerId, data.objectId));
      
      //this.car$ = store.select(selectCurrentCar);

      this.car$ = store.select(selectProviderOffer(data.objectSource, data.carId, data.businessLine, data.offerId));
      
      this.todayDate = new Date();
      this.tomorrowDate = new Date(this.todayDate);
      this.yesterdayDate = new Date(this.todayDate);

      this.tomorrowDate.setDate(this.todayDate.getDate()+1);
      this.yesterdayDate.setDate(this.todayDate.getDate()-1);

      this.selectedDateRange = new DateRange<Date>(this.todayDate, this.tomorrowDate);

      this.car$.subscribe(
        (result: Car | null) => {
          if(result == null){
            this.car = new Car()
            //this.booking.offerId = this.data.offerId;
          }
          else{
            this.car = Object.assign(new Car(), result)
            //this.car = JSON.parse(JSON.stringify(result))
          }
        }
      );
    }

    ngOnInit(): void {
      //this.isReschedule = (this.data.rescheduleDate ==='1');
      this.currentUserId$.subscribe(
          (id: string) => this.currentUserId = id
      );
  
      this.booking$.subscribe(
        (result: Booking | undefined) => {
          if(result == undefined){
            this.booking = new Booking()
            this.booking.offerId = this.data.offerId;
            this.booking.carDayRate = this.car.rentDayRate.amount
            this.booking.insuranceDayRate = this.car.rentInsuranceDayRate.amount
            this.booking.driverDayRate = this.car.rentDriverDayRate.amount
            this.booking.currency = this.car.rentDayRate.currency
          }
          else{
            this.booking = Object.assign(new Booking(), result)
            //this.booking = JSON.parse(JSON.stringify(result))
          }
          //this.reply = ""
        }
      );

      this.car$.subscribe(
        (result: Car | null) => {
          if(result == null){
            this.car = new Car()
            //this.booking.offerId = this.data.offerId;
          }
          else{
            this.car = Object.assign(new Car(), result)
            //this.car = JSON.parse(JSON.stringify(result))
          }
        }
      );

      this.isCompletion = this.data.objectAction! === BookingAction.COMPLETE
      this.isModification = this.data.objectAction! === BookingAction.EDIT_MODIF

      if(this.isModification && this.booking.modification === null){
        this.booking.modification = new BookingModif();
        this.booking.modification.id = this.booking.id
      }
    } 
  
    onNoClick(): void {
      this.dialogRef.close();
    }
    
    /*
    submitBooking(){
    
      if(this.booking.id === 0){
        console.log('new')
        this.store.dispatch(RentActions.bookingNewSubmit({ booking: this.booking, objectSource: this.data.objectSource }));
      }
      else{
        if(this.isReschedule){
          console.log('reschedule')
          //this.store.dispatch(RentActions.bookingRescheduleSubmit ( { bookingId: this.booking.id, rescDate: this.booking.rescheduleDate, objectSource: this.data.objectSource }));
        }
  
        else{
          console.log('update')
          this.store.dispatch(RentActions.bookingUpdateSubmit({ booking: this.booking, objectSource: this.data.objectSource }));         
        } 
      }
      this.dialogRef.close();
    }
      */

    submitBooking(){
        
      if(this.booking.id === 0){
        console.log('new')
        this.store.dispatch(RentActions.bookingNewSubmit({ booking: this.booking, objectSource: this.data.objectSource }));
      }
      else{
        if(this.isModification){
          console.log('modif')
          //this.store.dispatch(BuyActions.bookingRescheduleSubmit ( { bookingId: this.booking.id, rescDate: this.booking.rescheduleDate, objectSource: this.data.objectSource }));
          this.store.dispatch(RentActions.bookingActionSubmit({ bookingAction: BookingAction.EDIT_MODIF, booking: this.booking.modification!, objectSource: this.data.objectSource }));
        }
  
        else{
          console.log('update or complete')
          this.store.dispatch(RentActions.bookingActionSubmit({ bookingAction: this.data.objectAction as BookingAction, booking: this.booking, objectSource: this.data.objectSource }));         
        } 
      }
      this.dialogRef.close();
    }

    onInsuranceOptionChange(){
  
    }
  
    
    onMileageOptionChange(){
  
    }
  
    onWithDriverChange(){
      if(this.booking.withDriver)
        this.booking.customerDriving = false;
  
    }
  
    onCustomerDrivingChange(){
      if(this.booking.customerDriving)
        this.booking.withDriver = false;
    }
  
    onSelectedDatesChange(event: any){
      console.log('hellooo '+event.value);
      
    }
  
    filterPastDates = (date: Date | null): boolean => {
      return (date! > this.yesterdayDate);
    }
  
    filterPastDatesAndBookedDates = (date: Date | null): boolean => {
  
      let available: boolean = true;
  
      if ( ! (date! > this.yesterdayDate) ) {
        return false;
      } 
  
      this.car.allBookings.forEach(
        (booking: Booking) => {
          if (booking.endDate >= ""+date!.valueOf() && ""+date!.valueOf()  >= booking.startDate && booking.status != BookingStatus.CANCELLED) {
            available = false;
            return;
          }
        }
      );
      return available;
    }
  
    dateFormat(dt: string): string{
  
      return AppFunctions.stringToDate(dt);
    }
  
    moneyFormat(s: string): string{
      return AppFunctions.numberWithSpaces(s);
    }
  
    calculateCarAmount(){
      return this.booking.getTotalDuration() * this.booking.carDayRate;
    }
  
    calculateInsuranceAmount(){
      return this.booking.getTotalDuration() * this.booking.insuranceDayRate;
    }
  
    calculateDriverAmount(){
      return this.booking.getTotalDuration() * this.booking.driverDayRate;
    }
  
    calculateTotalAmount(){
      return this.calculateCarAmount() + this.calculateInsuranceAmount() + (this.calculateDriverAmount()*+this.booking.withDriver)
    }
  
    calculateAmountToPay() {
  
      console.log(this.paymentTermOptions[this.currentPaymentTermOptionIndex])
  
      switch(this.paymentTermOptions[this.currentPaymentTermOptionIndex].code){
  
        case PaymentTermOption.PAY_ADVANCE : {
          return this.calculateTotalAmount() * (100 - this.DEPOSIT_PERCENT)/100;
        }
  
        case PaymentTermOption.PAY_NOW : {
          return this.calculateTotalAmount() * (100 - this.PAY_NOW_PERCENT)/100;
        }
  
        case PaymentTermOption.PAY_LATER : {
          return 0;
        }
  
        default: {
          return this.calculateTotalAmount();
        }
      }
      
    }
  

}


